import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { none, TermsScreen } from './termsScreen';

interface TermsState {
  viewModel: TermsScreen.ViewModel;
}

const initialState: TermsState = {
  viewModel: none(''),
};

export const termsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<TermsScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = termsSlice.actions;

export default termsSlice.reducer;
